import { SVGProps } from "react";

const BuildingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="29"
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8264 0.625C15.0565 0.628469 15.2831 0.699 15.4762 0.834282C15.7849 1.0505 15.9688 1.40431 15.9688 1.78125V27.2188C15.9688 27.8524 15.4588 28.3669 14.8275 28.375H14.8125H2.09375C1.4555 28.375 0.9375 27.857 0.9375 27.2188C0.9375 27.2188 0.9375 12.9194 0.9375 8.02616C0.9375 6.56697 1.84978 5.26503 3.22109 4.76553C6.59734 3.53875 14.4171 0.694375 14.4171 0.694375C14.5396 0.650437 14.6657 0.627313 14.7917 0.625H14.809H14.8264ZM18.2812 10.1039L21.9604 11.6799C23.2358 12.2268 24.0625 13.4813 24.0625 14.8688V27.2188C24.0625 27.857 23.5445 28.375 22.9062 28.375H18.0835C18.2119 28.0131 18.2812 27.6246 18.2812 27.2188V10.1039ZM10.2025 20.2812C10.8338 20.2732 11.3438 19.7586 11.3438 19.125C11.3438 18.4867 10.8258 17.9688 10.1875 17.9688H6.71875C6.0805 17.9688 5.5625 18.4867 5.5625 19.125C5.5625 19.7633 6.0805 20.2812 6.71875 20.2812H10.1875H10.2025ZM10.2025 15.6562C10.8338 15.6482 11.3438 15.1336 11.3438 14.5C11.3438 13.8617 10.8258 13.3438 10.1875 13.3438H6.71875C6.0805 13.3438 5.5625 13.8617 5.5625 14.5C5.5625 15.1383 6.0805 15.6562 6.71875 15.6562H10.1875H10.2025ZM10.2025 11.0312C10.8338 11.0232 11.3438 10.5086 11.3438 9.875C11.3438 9.23675 10.8258 8.71875 10.1875 8.71875H6.71875C6.0805 8.71875 5.5625 9.23675 5.5625 9.875C5.5625 10.5133 6.0805 11.0312 6.71875 11.0312H10.1875H10.2025Z"
        fill="#69CFFD"
      />
    </svg>
  );
};

export default BuildingIcon;
